import cn from "classnames";
import PanelTemplate from "components/shared/profile/panel";
import UploadSigningFiles from "components/shared/uploadSigningFiles";
import { formatInitial } from "helpers/form";
import Tooltip from "rc-tooltip";
import React from "react";
import { uploadAccountantSigningFiles, uploadSigningFiles } from "sources/profile/organization";
import { accountantConfig as config, accountantInitialState as initialState } from "./config";

class Management extends PanelTemplate {
    updateSignFiles = (rest) => {
        this.props.modal({
            name: "default",
            title: "Файлы печати и подписи",
            CustomBody: UploadSigningFiles,
            bodyData: { refreshData: this.props.update, ...rest },
        });
    };

    componentDidUpdate(prevProps) {
        this.syncDataFromProps(prevProps);

        if (prevProps.data !== this.props.data) {
            this.setState({ data: formatInitial(this.props.data, initialState) });
        }
    }

    renderBody = () => {
        const { editable, config, management } = this.props;
        const { position, lastName, firstName, patronymic } = config;

        const { signature } = this.props.data ?? {};
        return (
            <>
                <div className="row">
                    <div className="col-sm-4">
                        <h5>
                            Руководство
                            <span className="col-1 text-center pl-1 col-form-label col-form-label-sm">
                                <Tooltip
                                    overlay="Информация по руководителю организации заполняется автоматически при формировании первого документа в системе"
                                    overlayClassName="book-form__tooltip"
                                >
                                    <i className="icon-uEA59-question book-form__tooltip-icon" />
                                </Tooltip>
                            </span>
                        </h5>
                    </div>
                    <div className="col-sm-8">
                        <div className="row mb-2">
                            <label className="col-form-label col-form-label-sm col-12 text-muted">Должность</label>
                            <div className="col-12">{management.position}</div>
                        </div>
                        <div className="row mb-2">
                            <label className="col-form-label col-form-label-sm col-12 text-muted">Фамилия</label>
                            <div className="col-12">{management.lastName}</div>
                        </div>
                        <div className="row mb-2">
                            <label className="col-form-label col-form-label-sm col-12 text-muted">Имя</label>
                            <div className="col-12">{management.firstName}</div>
                        </div>
                        <div className="row mb-2">
                            <label className="col-form-label col-form-label-sm col-12 text-muted">Отчество</label>
                            <div className="col-12">{management.patronymic}</div>
                        </div>
                        <div className="row mb-2">
                            <label className="col-form-label col-form-label-sm col-12 text-muted">
                                Подпись и печать
                            </label>
                            <div className="col-12">
                                <div className="d-flex gap-2 mb-2 align-items-center">
                                    {management.stamp && (
                                        <img
                                            className="mw-150"
                                            src={`data:image/png;base64,${management.stamp}`}
                                            alt="Печать"
                                        />
                                    )}
                                    {management.signature && (
                                        <img
                                            className="mw-150"
                                            src={`data:image/png;base64,${management.signature}`}
                                            alt="Подпись"
                                        />
                                    )}
                                </div>
                                <div
                                    className="btn btn-xs btn-secondary"
                                    onClick={() => this.updateSignFiles({ action: uploadSigningFiles })}
                                >
                                    Обновить печать и подпись
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-4">
                        <h5>Бухгалтерия</h5>
                    </div>
                    <div className="col-sm-8">
                        {this.renderField({ ...position, disabled: !editable })}
                        {this.renderField({ ...lastName, disabled: !editable })}
                        {this.renderField({ ...firstName, disabled: !editable })}
                        {this.renderField({ ...patronymic, disabled: !editable })}
                        <div className="row mb-2">
                            <label className="col-form-label col-form-label-sm col-12 text-muted">Подпись</label>
                            <div className="col-12">
                                <div className="d-flex gap-2 mb-2">
                                    {signature && (
                                        <img
                                            className="mw-150"
                                            src={`data:image/png;base64,${signature}`}
                                            alt="Подпись"
                                        />
                                    )}
                                </div>
                                <div
                                    className="btn btn-xs btn-secondary"
                                    onClick={() =>
                                        this.updateSignFiles({
                                            action: uploadAccountantSigningFiles,
                                            onlySignature: true,
                                        })
                                    }
                                >
                                    Обновить подпись
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    render() {
        const cname = cn("card card-body mb-3", {
            "border-danger book-form__body--invalid": !this.state.isValid,
        });
        return (
            <div className={cname}>
                {this.renderBody()}
                {this.renderButton()}
            </div>
        );
    }
}

const ConfiguredPanel = (props) => <Management {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
